import moment from 'moment';

export const BOOKING_PAYMENT_KEY = 'booking_payment_form';
const formFields = [
  'from_date',
  'to_date',
  'number_of_days',
  'checkin',
  'number_of_adults',
  'number_of_children',
  'selectedBoatId',
  'boat_length',
  'boat_beam',
  'boat_draft',
  'boat_type',
  'boat_name',
  'boat_registration_number',
];

export function saveBookingPayment(state, mooringId) {
  const form = Object.fromEntries(formFields.map((key) => [key, state[key]]));
  sessionStorage.setItem(
    BOOKING_PAYMENT_KEY,
    JSON.stringify({
      mooringId: String(mooringId),
      form,
      tokenIds: state.payrexx_tokenizations.map((item) => String(item.id)),
    }),
  );
}

export function clearBookingPayment() {
  try {
    sessionStorage.removeItem(BOOKING_PAYMENT_KEY);
  } catch {
    // Storage can be unavailable in a returning webview.
  }
}

export function restoreBookingPayment(mooringId) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(BOOKING_PAYMENT_KEY));
    if (!saved || saved.mooringId !== String(mooringId)) return null;
    sessionStorage.removeItem(BOOKING_PAYMENT_KEY);
    const form = Object.fromEntries(
      formFields
        .filter((key) => Object.prototype.hasOwnProperty.call(saved.form, key))
        .map((key) => [key, saved.form[key]]),
    );
    form.from_date = moment(form.from_date);
    form.to_date = moment(form.to_date);
    if (!form.from_date.isValid() || !form.to_date.isValid()) return null;
    return { form, tokenIds: saved.tokenIds || [] };
  } catch {
    return null;
  }
}

export function paymentRedirectUrls(location, mooringId, checkin) {
  const url = new URL(location.href);
  // A modal's parent URL may not reopen it after a full page navigation.
  url.pathname = `/Booking/${encodeURIComponent(mooringId)}${checkin ? '/checkin' : ''}`;
  return Object.fromEntries(
    ['success', 'failed', 'cancel'].map((status) => {
      url.searchParams.set('pm', status[0]);
      return [`${status}_url`, url.toString()];
    }),
  );
}
